<template>
    <div>
        <section>
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')"
                            sizes="(max-width: 479px) 100vw, 84.03125px"
                            :srcset="`${require('@/assets/images/NewSelf_Logo-p-500.png')} 500w, ${require('@/assets/images/NewSelf_Logo-p-800.png')} 800w`"
                            loading="lazy" class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="questionId > 1 ? questionId-- : null"
                            class="back-link w-inline-block">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>3</strong> of <strong>3</strong> Pre-Qualify
                                </div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / 21) * 100)
                                        }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                        <div class="text-block-505"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-7">
            <div class="questions-div">
                <!-- Question 1: Name -->
                <div class="question-container" v-if="questionId === 1">
                    <div class="question-div-2">
                        <div class="text-block-513">Who do I have the pleasure of talking to?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1476">
                                    <input class="text-field-43 w-input" maxlength="256" v-model="people.first_name"
                                        placeholder="First Name" type="text" required>
                                    <input class="text-field-43 w-input" maxlength="256" v-model="people.last_name"
                                        placeholder="Last Name" type="text" required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Question 2: Gender -->
                <div class="question-container" v-if="questionId === 2">
                    <div class="question-div-2">
                        <div class="text-block-513">What was your gender at birth?</div>
                        <div class="form-subs">This will help our doctors recommend the proper medications and dosages.
                        </div>
                        <div class="felix-form-block w-form">
                            <a href="#" @click.prevent="setValue('gender', 'Female')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d8197d38318417c44d9c4_Female.svg"
                                        class="image-307" loading="lazy">
                                    <div class="text-block-545">Female</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="setValue('gender', 'Male')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d81974f75b229e7b38302_Male.svg"
                                        class="image-307" loading="lazy">
                                    <div class="text-block-545">Male</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Question 3: Date of Birth -->
                <div class="question-container" v-if="questionId === 3">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your date of birth?</div>
                        <div class="form-subs">Based on your date of birth our doctors can prescribe the proper
                            prescription.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateDOB">
                                <div class="div-block-1470 mobile-entry form _2 birth">
                                    <select v-model="people.dob.mm" class="select-field-5 felix w-select" required>
                                        <option value="">Month</option>
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                    <div class="text-block-518">-</div>
                                    <input class="phone-number-field-3 form birth felix w-input" maxlength="2"
                                        pattern="[0-9]*" v-model="people.dob.dd" placeholder="Day" type="text" required>
                                    <div class="text-block-518">-</div>
                                    <input class="phone-number-field-3 _2 form birth felix w-input" maxlength="4"
                                        pattern="[0-9]*" v-model="people.dob.yyyy" placeholder="Year" type="text"
                                        required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Question 4: Height and Weight -->
                <div class="question-container" v-if="questionId === 4">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your height and weight?</div>
                        <div class="form-subs">We'll use this to determine your Body mass Index (BMI) for diagnosis.
                            remember, BMI is a measure of size - not health</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateHeightWeight">
                                <div class="div-block-1478 mobile-entry form _2 height top">
                                    <input class="text-field-44 height w-input" maxlength="256"
                                        v-model="people.height.ft" placeholder="Feet" type="text" @keyup="calculateBMI" required>
                                    <input class="text-field-44 height w-input" maxlength="256"
                                        v-model="people.height.inch" placeholder="Inches" type="text" @keyup="calculateBMI" required>
                                </div>
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input class="text-field-45 weight w-input" maxlength="256" @keyup="calculateBMI" v-model="people.weight"
                                        placeholder="Weight in pounds" type="text" required>
                                </div>
                                <div v-if="people.bmi" class="bmi-result">
                                    Your BMI: {{ people.bmi.toFixed(1) }}
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 5: Symptoms to Treat -->
                <div class="question-container" v-if="questionId === 5">
                    <div class="question-div-2">
                        <div class="text-block-513">What symptoms would you like to treat?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <!-- Male Symptoms -->
                                <div class="multi-choice-boxes-div" v-if="people.gender === 'Male'">
                                    <label v-for="(symptom, index) in maleSymptoms" :key="'male-' + index"
                                        class="w-checkbox checkbox-field-multibox">
                                        <div :class="[
                                            'w-checkbox-input',
                                            'w-checkbox-input--inputType-custom',
                                            'checkbox-13',
                                            { 'w--redirected-checked': people.symptoms.includes(symptom.label) }
                                        ]"></div>
                                        <input type="checkbox" :id="'checkbox-' + index" :name="'checkbox-' + index"
                                            :data-name="'Checkbox ' + index" v-model="people.symptoms"
                                            :value="symptom.label" style="opacity:0;position:absolute;z-index:-1">
                                        <img :src="require(`@/assets/images/${symptom.icon}`)" loading="lazy" alt=""
                                            class="image-384">
                                        <span class="checkbox-label-14-check w-form-label" :for="'checkbox-' + index">
                                            {{ symptom.label }}
                                            <span v-if="symptom.subLabel" class="text-span-178">({{ symptom.subLabel
                                                }})</span>
                                        </span>
                                    </label>
                                </div>

                                <!-- Female Symptoms -->
                                <div class="multi-choice-boxes-div" v-if="people.gender === 'Female'">
                                    <label v-for="(symptom, index) in femaleSymptoms" :key="'female-' + index"
                                        class="w-checkbox checkbox-field-multibox">
                                        <div :class="[
                                            'w-checkbox-input',
                                            'w-checkbox-input--inputType-custom',
                                            'checkbox-13',
                                            { 'w--redirected-checked': people.symptoms.includes(symptom.label) }
                                        ]"></div>
                                        <input type="checkbox" :id="'checkbox-' + index" :name="'checkbox-' + index"
                                            :data-name="'Checkbox ' + index" v-model="people.symptoms"
                                            :value="symptom.label" style="opacity:0;position:absolute;z-index:-1">
                                        <img :src="require(`@/assets/images/${symptom.icon}`)" loading="lazy" alt=""
                                            class="image-384">
                                        <span class="checkbox-label-14-check w-form-label" :for="'checkbox-' + index">
                                            {{ symptom.label }}
                                            <span v-if="symptom.subLabel" class="text-span-178">({{ symptom.subLabel
                                                }})</span>
                                        </span>
                                    </label>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->" v-if="people.symptoms.length>0">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 6: Desired Weight -->
                <div class="question-container" v-if="questionId === 6">
                    <div class="question-div-2">
                        <div class="text-block-513">Ok so if you weigh {{ people.weight }} lbs. now...What is your
                            desired weight?</div>
                        <div class="form-subs">It will help our doctors recommend treatments to help you achieve your
                            goals.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1481 b">
                                    <div class="div-block-1480 mobile-entry form _2 weight">
                                        <input class="text-field-46 weight w-input" maxlength="256"
                                            v-model="people.desired_weight"
                                            placeholder="What is your goal weight in pounds?" type="text" required>
                                    </div>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 7: Weight Concern Duration -->
                <div class="question-container" v-if="questionId === 7">
                    <div class="question-div-2">
                        <div class="text-block-513">How long have you had concerns about your weight?</div>
                        <div class="form-subs">Understanding if there's been a recent change will help us make an more
                            accurate diagnosis.</div>
                        <div class="felix-form-block w-form">
                            <form>
                                <a href="#"
                                    @click.prevent="setValue('concerned_about_weight_for', 'Less than 6 months')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Less than 6 months</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('concerned_about_weight_for', '6-12 months')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">6-12 months</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('concerned_about_weight_for', '1-5 years')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">1-5 years</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('concerned_about_weight_for', 'More than 5 years')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">More than 5 years</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 8: Weight Impact -->
                <div class="question-container" v-if="questionId === 8">
                    <div class="question-div-2">
                        <div class="text-block-513">Does your weight negatively affect your physical or mental health?
                        </div>
                        <div class="form-subs">Mental health plays a large role in your physical well being.</div>
                        <div class="felix-form-block w-form">
                            <form>
                                <a href="#" @click.prevent="setValue('weight_affect_health', 'Yes, a lot')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Yes, a lot</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('weight_affect_health', 'Yes, somewhat')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Yes, somewhat</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('weight_affect_health', 'Not much')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Not much</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('weight_affect_health', 'Not at all')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Not at all</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 9: Weight Loss Goal -->
                <div class="question-container" v-if="questionId === 9">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your weight loss goal?</div>
                        <div class="form-subs">This helps us to recommend the proper medication to reach your goal.
                        </div>
                        <div class="felix-form-block w-form">
                            <form>
                                <a href="#" @click.prevent="setValue('weight_loss_goal', 'Lose 1-20 lbs.')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Lose 1-20 lbs.</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('weight_loss_goal', 'Lose 21-50 lbs.')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Lose 21-50 lbs.</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('weight_loss_goal', 'Lose over 50 lbs')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Lose over 50 lbs</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('weight_loss_goal', 'Haven\'t decided')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Haven't decided</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 10: Goals to Accomplish -->
                <div class="question-container" v-if="questionId === 10">
                    <div class="question-div-2">
                        <div class="text-block-513">What goals are you looking to accomplish?</div>
                        <div class="form-subs">Establishing clear goals will help our clinicians tailor a custom plan
                            just for you.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Lose Weight"
                                        v-model="people.goals_are_you_looking_to_accomplish"
                                        class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">Lose Weight</span>
                                </label>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Improve General Health"
                                        v-model="people.goals_are_you_looking_to_accomplish"
                                        class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">Improve General Health</span>
                                </label>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Look Better"
                                        v-model="people.goals_are_you_looking_to_accomplish"
                                        class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">Look Better</span>
                                </label>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Improve Confidence"
                                        v-model="people.goals_are_you_looking_to_accomplish"
                                        class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">Improve Confidence</span>
                                </label>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Increase Energy"
                                        v-model="people.goals_are_you_looking_to_accomplish"
                                        class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">Increase Energy</span>
                                </label>
                                <input type="submit" class="form-button w-button" value="Next ->" v-if="people.goals_are_you_looking_to_accomplish.length>0">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 11: Past Weight Loss Attempts -->
                <div class="question-container" v-if="questionId === 11">
                    <div class="question-div-2">
                        <div class="text-block-513">What have you tried in the past?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Exercise" v-model="people.tried_in_past"
                                        class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label"><strong>Exercise</strong></span>
                                </label>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Dieting" v-model="people.tried_in_past"
                                        class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label"><strong>Dieting</strong></span>
                                </label>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Weight Loss Supplements"
                                        v-model="people.tried_in_past" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">Weight Loss Supplements</span>
                                </label>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Medical weight loss program"
                                        v-model="people.tried_in_past" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">Medical weight loss program</span>
                                </label>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" value="Intermittent Fasting" v-model="people.tried_in_past"
                                        class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">Intermittent Fasting</span>
                                </label>
                                <input type="submit" class="form-button w-button" value="Next ->" v-if="people.tried_in_past.length>0">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 12: Prior Surgery -->
                <div class="question-container" v-if="questionId === 12">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you had prior bariatric (weight loss) surgery or any
                            abdominal/pelvic surgeries?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="disqualifiedLead()" class="button-68 w-button">YES</a>
                                <a href="#" @click.prevent="nextQuestion()" class="button-68 w-button">NO</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Question 13: Medical Conditions -->
                <div class="question-container" v-if="questionId === 13">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have any of these medical conditions?</div>
                        <div class="form-subs">Any of these complications may disqualify you from weight loss medication
                            approval. "None" is the best answer.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="checkMedicalCondition">
                                <div class="disclaimer-box">
                                    <div class="div-block-1488">
                                        <div class="text-block-538">!</div>
                                    </div>
                                    <p class="paragraph-102">Any of these complications may disqualify you from weight
                                        loss medication approval. <strong>&quot;None&quot; is the best answer.</strong>
                                    </p>
                                </div>
                                <input type="submit" data-wait="Please wait..." class="form-button none w-button" value="None (Best Answer) -&gt;">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="med in medicalcon" :key="med">
                                    <input type="checkbox" name="checkbox-3" id="checkbox-3" :value="med" data-name="Checkbox 3" v-model="people.medical_condition" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3" v-html="med"></span>
                                </label>

                                <input type="submit" class="form-button w-button" value="Next ->" v-if="people.medical_condition.length>0">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 14: GLP Weight Loss Medications -->
                <div class="question-container" v-if="questionId === 14">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you currently take any GLP Weight Loss Medications?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="setValue('currently_taking_glp', 'Yes')"
                                    class="button-68 w-button">YES</a>
                                <a href="#" @click.prevent="setValue('currently_taking_glp', 'No')"
                                    class="button-68 w-button">NO</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Question 15: Current Medication -->
                <div class="question-container" v-if="questionId === 15">
                    <div class="question-div-2">
                        <div class="text-block-513">What medication do you currently take?</div>
                        <div class="felix-form-block w-form">
                            <a href="#" @click.prevent="setValue('name_current_med', 'Ozempic / Wegovy')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">Ozempic / Wegovy</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="setValue('name_current_med', 'Mounjaro / Zepbound')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">Mounjaro / Zepbound</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="setValue('name_current_med', 'Semaglutide Compound')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">Semaglutide Compound</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="setValue('name_current_med', 'Tirzepatide Compound')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">Tirzepatide Compound</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Question 16: State Selection -->
                <div class="question-container" v-if="questionId === 16">
                    <div class="question-div-2">
                        <div class="text-block-513">What state do you reside in?</div>
                        <div class="form-subs">We need to match you to a licensed clinician in your state.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="checkState">
                                <select v-model="people.state" required class="select-field-7 form w-select">
                                    <option value="" disabled selected>State...</option>
                                    <option v-for="(value, key) in allstate" :key="key" :value="value">{{ key }}
                                    </option>
                                </select>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 17: Phone Number -->
                <div class="question-container" v-if="questionId === 17">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your mobile phone number?</div>
                        <div class="form-subs">Enter the best phone to reach you on just in case your doctor has any
                            questions regarding your medical information.</div>
                        <div class="checks-div">
                            <div class="bullet-div">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Updates from your doctor</div>
                            </div>
                            <div class="bullet-div">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Shipping notifications</div>
                            </div>
                            <div class="bullet-div">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Prescription alerts</div>
                            </div>
                            <div class="bullet-div">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Latest offers from NewSelf</div>
                            </div>
                        </div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="phone-entry-div felix">
                                    <input class="phone-number-field-3 _1 form w-input" pattern="[0-9]*" maxlength="3"
                                        minlength="3" @keyup="focusNext" v-model="people.phone_part.part1"
                                        placeholder="(000)" type="text" required>
                                    <div class="text-block-539">-</div>
                                    <input class="phone-number-field-3 form w-input" pattern="[0-9]*" maxlength="3"
                                        minlength="3" @keyup="focusNext" v-model="people.phone_part.part2"
                                        placeholder="000" type="text" required>
                                    <div class="text-block-539">-</div>
                                    <input class="phone-number-field-3 _2 form w-input" pattern="[0-9]*" maxlength="4"
                                        minlength="4" @keyup="focusNext" v-model="people.phone_part.part3"
                                        placeholder="0000" type="text" required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                                <p class="paragraph-103">
                                    By clicking "Next," you agree to receive communications from NewSelf, including
                                    AI-generated calls, automated dialing systems, text messages,
                                    emails, and other communication methods, to the contact information provided. These
                                    communications may include promotions, updates, and
                                    follow-up information related to your inquiry or our services. Standard message and
                                    data rates may apply. You can opt-out at any time. For more
                                    details, please review our <a href="https://joinyara.com/privacy-policy-new"
                                        target="_blank">Privacy Policy</a>.
                                </p>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 18: Email -->
                <div class="question-container" v-if="questionId === 18">
                    <div class="question-div-2">
                        <div class="text-block-513">Please enter your email</div>
                        <div class="form-subs">We will send you confirmation of approval & discount offers.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateEmail">
                                <input class="text-field-47 email form w-input" maxlength="256" v-model="people.email"
                                    placeholder="Enter your email" type="email" :class="{ 'text-danger': isError }"
                                    required>
                                <button class="form-button w-button" :disabled="loading" style="padding-top: 15px;">
                                    <div class="div-block-817" v-if="loading">
                                        <img src="@/assets/images/submitted.svg">
                                    </div>
                                    <div class="div-block-817" v-else>
                                        <div class="text-block-199">Next -></div>
                                    </div>
                                </button>
                                <p class="paragraph-103">
                                    By clicking "Next," you agree to receive communications from NewSelf, including
                                    AI-generated calls, automated dialing systems, text messages,
                                    emails, and other communication methods, to the contact information provided. These
                                    communications may include promotions, updates, and
                                    follow-up information related to your inquiry or our services. Standard message and
                                    data rates may apply. You can opt-out at any time. For more
                                    details, please review our <a href="https://joinyara.com/privacy-policy-new"
                                        target="_blank">Privacy Policy</a>.
                                </p>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 19: Results Summary -->
                <div class="question-container" v-if="questionId === 19">
                    <div class="question-div-2">
                        <div class="div-block-1450 end">
                            <div class="text-block-517">You Qualify, {{ people.first_name }}!</div>
                        </div>
                        <div class="text-block-513 end">You are the perfect candidate for our Weight Loss Program.</div>
                        <div class="form-subs end">You could lose up to 32 pounds in the next 90 days if you follow the
                            NewSelf weight loss program</div>
                        <div class="checks-div end">
                            <div class="bullet-div end">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Lose weight for <strong>1/4 the price</strong> of drugs like
                                    Ozempic & Mounjaro.</div>
                            </div>
                            <div class="bullet-div end">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Meet with US-based doctor <strong>over quick video
                                        call.</strong></div>
                            </div>
                            <div class="bullet-div end">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Get your medication deliver to your door <strong>in 3-5
                                        days.</strong></div>
                            </div>
                        </div>
                        <div class="report-summary-div">
                            <div class="div-block-1685">
                                <div class="div-block-1675">
                                    <div class="div-block-1698">
                                        <div class="div-block-1683">
                                            <div class="text-block-735">{{ people.first_name }}, This is the start of
                                                your weight loss journey</div>
                                        </div>
                                        <div class="div-block-1674">
                                            <div class="div-block-1696">
                                                <div class="text-block-732">Your Current Weight is</div>
                                                <div class="text-block-720">{{ people.weight }} <span
                                                        class="text-span-176">lbs</span></div>
                                            </div>
                                            <div class="div-block-1696">
                                                <div class="text-block-732">Your Target Weight is</div>
                                                <div class="text-block-720">{{ people.desired_weight }} <span
                                                        class="text-span-176">lbs</span></div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Weight Loss Projections -->
                                    <div class="div-block-1695">
                                        <div class="table-header-2">Weight Loss Projections<br>for <strong>{{
                                                people.first_name }}</strong></div>
                                        <div class="div-block-1689">
                                            <div class="table-row-div-2 top">
                                                <div class="div-block-1684">
                                                    <div class="text-block-723 top">Program</div>
                                                </div>
                                                <div class="div-block-1692">
                                                    <div class="text-block-723 top">% Loss</div>
                                                </div>
                                                <div class="div-block-1686">
                                                    <div class="text-block-723 top">Weight Loss</div>
                                                </div>
                                                <div class="div-block-1699">
                                                    <div class="text-block-723 top">New Weight</div>
                                                </div>
                                            </div>

                                            <div class="table-row-div-2">
                                                <div class="div-block-1684">
                                                    <div class="text-block-723">Avg. Weight Loss on Semaglutide</div>
                                                </div>
                                                <div class="div-block-1692">
                                                    <div class="text-block-716">16%</div>
                                                </div>
                                                <div class="div-block-1686">
                                                    <div class="text-block-716">{{ Math.round(people.weight * 0.16) }}
                                                        <span class="text-span-175">lbs</span></div>
                                                </div>
                                                <div class="div-block-1699">
                                                    <div class="text-block-716">{{ Math.round(people.weight * 0.84) }}
                                                        <span class="text-span-175">lbs</span></div>
                                                </div>
                                            </div>

                                            <div class="table-row-div-2">
                                                <div class="div-block-1684">
                                                    <div class="text-block-723">Avg. Weight Loss on Tirzepatide</div>
                                                </div>
                                                <div class="div-block-1692">
                                                    <div class="text-block-716">22%</div>
                                                </div>
                                                <div class="div-block-1686">
                                                    <div class="text-block-716">{{ Math.round(people.weight * 0.22) }}
                                                        <span class="text-span-175">lbs</span></div>
                                                </div>
                                                <div class="div-block-1699">
                                                    <div class="text-block-716">{{ Math.round(people.weight * 0.78) }}
                                                        <span class="text-span-175">lbs</span></div>
                                                </div>
                                            </div>

                                            <div class="table-row-div-2">
                                                <div class="div-block-1684">
                                                    <div class="text-block-723">1 in 3 lose more on Semaglutide</div>
                                                </div>
                                                <div class="div-block-1692">
                                                    <div class="text-block-716">23%</div>
                                                </div>
                                                <div class="div-block-1686">
                                                    <div class="text-block-716">{{ Math.round(people.weight * 0.23) }}
                                                        <span class="text-span-175">lbs</span></div>
                                                </div>
                                                <div class="div-block-1699">
                                                    <div class="text-block-716">{{ Math.round(people.weight * 0.77) }}
                                                        <span class="text-span-175">lbs</span></div>
                                                </div>
                                            </div>

                                            <div class="table-row-div-2">
                                                <div class="div-block-1684">
                                                    <div class="text-block-723">1 in 5 on NewSelf's Program Lose</div>
                                                </div>
                                                <div class="div-block-1692">
                                                    <div class="text-block-716">31%</div>
                                                </div>
                                                <div class="div-block-1686">
                                                    <div class="text-block-716">{{ Math.round(people.weight * 0.31) }}
                                                        <span class="text-span-175">lbs</span></div>
                                                </div>
                                                <div class="div-block-1699">
                                                    <div class="text-block-716">{{ Math.round(people.weight * 0.69) }}
                                                        <span class="text-span-175">lbs</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href="#" @click.prevent="questionId++" class="button-65 finish w-button">
                            Start Your Weight Loss Journey <span class="text-span-177">-></span>
                        </a>
                    </div>
                </div>

                <!-- Question 20: Recommended Medications -->
                <div class="question-container" v-if="questionId === 20">
                    <div class="question-div-2">
                        <div class="text-block-513">Here's what we recommend</div>
                        <div class="div-block-1681">
                            <img src="@/assets/images/steps_doc.png" loading="lazy" class="image-382">
                            <div>Your healthcare practicioner will review your treatment with you before it's finalized.
                            </div>
                        </div>
                        <div class="telehealth-button-div">
                            <!--<a href="#" class="link-block-47 w-inline-block">
                                <img src="@/assets/images/icon_call.svg" loading="lazy" class="image-379">
                                <div class="text-block-711">Talk with a Care Concierge</div>
                            </a>-->
                        </div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1644 products">
                                <!-- Tirzepatide Option -->
                                <a href="#" @click.prevent="setValue('plan_selected', 'Tirzepatide')"
                                    class="link-block-48 tirz w-inline-block">
                                    <div class="div-block-1643 tirz">
                                        <div class="text-block-719"><span class="text-span-174 tirz">Most
                                                Effective</span></div>
                                        <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d57bfc5a698f6031abeeb_yara%20placeholder.svg"
                                            loading="lazy" class="image-360">
                                        <div class="form-product-2">Trizepatide</div>
                                        <div class="text-block-724">COMPOUND</div>
                                        <div>Same active ingredient as <strong>Mounjaro® & Zepbound®</strong> for a
                                            fraction of the cost.</div>
                                        <div class="div-block-1645">
                                            <img src="@/assets/images/icon_Check.svg" loading="lazy" class="image-370">
                                            <div class="text-block-713">A once-weekly injection.</div>
                                        </div>
                                        <div class="div-block-1645">
                                            <img src="@/assets/images/icon_Check.svg" loading="lazy" class="image-370">
                                            <div class="text-block-713">Most Effective GLP-1</div>
                                        </div>
                                        <div class="div-block-1645">
                                            <img src="@/assets/images/icon_Check.svg" loading="lazy" class="image-370">
                                            <div class="text-block-713">Produced in the USA.</div>
                                        </div>
                                    </div>
                                    <div class="form-price-div felix">
                                        <div class="div-block-1697">
                                            <div class="div-block-1678">
                                                <img src="@/assets/images/icon_check_purp.svg" loading="lazy"
                                                    class="image-380">
                                                <div class="text-block-712">In stock</div>
                                            </div>
                                            <div class="div-block-1678">
                                                <img src="@/assets/images/icon_check_purp.svg" loading="lazy"
                                                    class="image-380">
                                                <div class="text-block-712">No insurance required</div>
                                            </div>
                                            <div class="div-block-1678">
                                                <img src="@/assets/images/icon_check_purp.svg" loading="lazy"
                                                    class="image-380">
                                                <div class="text-block-712">Express Shipping</div>
                                            </div>
                                        </div>
                                        <div class="form-price felix">
                                            <div class="text-block-696">Starting at</div>
                                            <div class="amount">
                                                <div class="text-block-728">$</div>
                                                <div class="text-block-714">449</div>
                                            </div>
                                            <div class="text-block-722">a month</div>
                                        </div>
                                    </div>
                                </a>

                                <!-- Semaglutide Option -->
                                <a href="#" @click.prevent="setValue('plan_selected', 'Semaglutide')"
                                    class="link-block-48 sema w-inline-block">
                                    <div class="div-block-1643 sema">
                                        <div class="text-block-719"><span class="text-span-174 sema">Most Popular</span>
                                        </div>
                                        <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d57bfc5a698f6031abeeb_yara%20placeholder.svg"
                                            loading="lazy" class="image-360">
                                        <div class="form-product-2">Semaglutide</div>
                                        <div class="text-block-724">COMPOUND</div>
                                        <div>Same active ingredient as <strong>Ozempic® & Wegovy®</strong> for a
                                            fraction of the cost.</div>
                                        <div class="div-block-1645">
                                            <img src="@/assets/images/icon_Check.svg" loading="lazy" class="image-370">
                                            <div class="text-block-713">A once-weekly injection.</div>
                                        </div>
                                        <div class="div-block-1645">
                                            <img src="@/assets/images/icon_Check.svg" loading="lazy" class="image-370">
                                            <div class="text-block-713">Most Prescribed GLP-1</div>
                                        </div>
                                        <div class="div-block-1645">
                                            <img src="@/assets/images/icon_Check.svg" loading="lazy" class="image-370">
                                            <div class="text-block-713">Produced in the USA.</div>
                                        </div>
                                    </div>
                                    <div class="form-price-div felix">
                                        <div class="div-block-1697">
                                            <div class="div-block-1678">
                                                <img src="@/assets/images/icon_check_purp.svg" loading="lazy"
                                                    class="image-380">
                                                <div class="text-block-712">In stock</div>
                                            </div>
                                            <div class="div-block-1678">
                                                <img src="@/assets/images/icon_check_purp.svg" loading="lazy"
                                                    class="image-380">
                                                <div class="text-block-712">No insurance required</div>
                                            </div>
                                            <div class="div-block-1678">
                                                <img src="@/assets/images/icon_check_purp.svg" loading="lazy"
                                                    class="image-380">
                                                <div class="text-block-712">Express Shipping</div>
                                            </div>
                                        </div>
                                        <div class="form-price felix">
                                            <div class="text-block-696">Starting at</div>
                                            <div class="amount">
                                                <div class="text-block-728">$</div>
                                                <div class="text-block-714">299</div>
                                            </div>
                                            <div class="text-block-722">a month</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="div-block-1503">
                                
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Question 21: Medication Preference -->
                <div class="question-container" v-if="questionId === 21">
                    <div class="question-div-2">
                        <div class="text-block-513 end">Do you prefer oral (pills) or injected (compound+syringe)
                            medication?</div>
                        <div class="form-subs end">Unless you are horrified of needles than we recommend for best
                            results to choose the once weekly injection...but it's up to you!</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1644 products">
                                <!-- Injection Option -->
                                <a href="#" @click.prevent="setValue('drug_mode_selected', 'Injection')"
                                    class="link-block-48 method inject w-inline-block">
                                    <div class="text-block-733">Injection</div>
                                    <div class="text-block-730">Most Effective.</div>
                                    <div class="div-block-1677">
                                        <img src="@/assets/images/icon_check-black2.svg" loading="lazy"
                                            class="image-381">
                                        <div class="text-block-721">Take once a week.</div>
                                    </div>
                                    <div class="div-block-1677">
                                        <img src="@/assets/images/icon_check-black2.svg" loading="lazy"
                                            class="image-381">
                                        <div class="text-block-721">Painless Injection.</div>
                                    </div>
                                    <div class="div-block-1677">
                                        <img src="@/assets/images/icon_check-black2.svg" loading="lazy"
                                            class="image-381">
                                        <div class="text-block-721">Best Results.</div>
                                    </div>
                                </a>

                                <!-- Oral Option -->
                                <a href="#" @click.prevent="setValue('drug_mode_selected', 'Oral')"
                                    class="link-block-48 method oral w-inline-block">
                                    <div class="text-block-733">Oral</div>
                                    <div class="text-block-730">Easier on the go.</div>
                                    <div class="div-block-1677">
                                        <img src="@/assets/images/icon_check-black2.svg" loading="lazy"
                                            class="image-381">
                                        <div class="text-block-721">Take Once a day.</div>
                                    </div>
                                    <div class="div-block-1677">
                                        <img src="@/assets/images/icon_check-black2.svg" loading="lazy"
                                            class="image-381">
                                        <div class="text-block-721">Best for Travel</div>
                                    </div>
                                    <div class="div-block-1677">
                                        <img src="@/assets/images/icon_check-black2.svg" loading="lazy"
                                            class="image-381">
                                        <div class="text-block-721">Less Effective.</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Question 22: Clinical Weight Loss Coach -->
                <div class="question-container" v-if="questionId === 22">
                    <div class="question-div-2">
                        <div class="text-block-513 end">Do you need a clinical weight loss coach along the way?</div>
                        <div class="form-subs end">You will get on a call every 2 weeks to check your progress. Our
                            clinical weight loss coaches will provide you with a custom weight loss plan. We found that
                            this helps keep you more accountable and lose weight faster.</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="setValue('want_coach', 1)"
                                    class="button-68 yes-hilight w-button">YES</a>
                                <a href="#" @click.prevent="setValue('want_coach', 0)"
                                    class="button-68 w-button">NO</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <div style="height: 320px;"></div>
    </div>
</template>

<script>
import state from "@/utils/state.json"

export default {
    name: 'HealthOptimizationQuiz',
    data() {
        return {
            baseUrl: `${process.env.VUE_APP_API_ENDPOINT}/api`,
            allstate: state,
            questionId: 1,
            isError: false,
            loading: false,
            medical_cond_to_ask:[
                "Type 2 diabetes ON INSULIN", 
                "Type 1 diabetes",
                "Diabetic retinopathy", 
                "End-stage liver disease (cirrhosis)", 
                "End-stage kidney disease<br>(on or about to be on dialysis)", 
                "Current or prior eating disorder (anorexia/bulimia)",
                "Current suicidal thoughts and/or prior<br>suicidal attempt",
                "History of organ transplant on<br>anti-rejection medication",
                "Severe gastrointestinal condition<br>(gastroparesis, blockage, inflammatory<br>bowel disease)",
                "Personal or family history of thyroid<br>cyst/nodule, thyroid cancer, medullary<br>thyroid carcinoma, or multiple<br>endocrine neoplasia syndrome type 2",
                "History of or current pancreatitis"
            ],
            doses: [
                { phase: 1, dose: 2.5 },
                { phase: 2, dose: 5 },
                { phase: 3, dose: 7.5 },
                { phase: 4, dose: 10 },
                { phase: 5, dose: 12.5 },
                { phase: 6, dose: 15 }
            ],
            people: {
                id: '',
                first_name: '',
                last_name: '',
                gender: 'Male',
                dob_yyyy_mm_dd:'',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
                height: {
                    ft: '',
                    inch: ''
                },
                weight: '',
                bmi:'',
                age:'',
                desired_weight: '',
                medical_condition:[],
                concerned_about_weight_for: '',
                heightInInches:'',
                dobMMDDYYYY:'',
                weight_affect_health: '',
                weight_loss_goal: '',
                goals_are_you_looking_to_accomplish: [],
                tried_in_past: [],
                state: '',
                phone_part: {
                    part1: '',
                    part2: '',
                    part3: ''
                },
                email: '',
                currently_taking_glp: 'No',
                name_current_med: 'none',
                phase_current_med: '',
                plan_selected: '',
                drug_mode_selected: '',
                want_coach: '',
                ip_address: '',
                aff_id: '',
                tid: '',
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_content: '',
                utm_term: '',
                symptoms:[],
                form_type: 'weightLoss',
            },
            maleSymptoms: [
                { label: 'Brain Fog, Difficulty Focusing', icon: 'icon_-Brain.svg' },
                { label: 'Low Energy', icon: 'icon_-low-Energy.svg' },
                { label: 'Difficulty Losing Weight', icon: 'Lose-Weight.svg' },
                { label: 'Increased Body Fat', subLabel: 'especially around the abdomen', icon: 'icon_-Body-Fat.svg' },
                { label: 'Muscle Weakness or Loss', subLabel: 'including reduced strength', icon: 'icon_-Weak.svg' },
                { label: 'Decreased Endurance', subLabel: 'physical and sexual stamina', icon: 'icon_-No-Endurance.svg' },
                { label: 'Low Libido or Erectile Dysfunction', subLabel: 'ED', icon: 'icon_-Libido.svg' },
                { label: 'Hair Thinning or Hair Loss', icon: 'icon_-Hair-Loss.svg' },
                { label: 'Poor Skin Quality', subLabel: 'wrinkles, sagging, dryness', icon: 'icon_-Skin.svg' },
                { label: 'Sleep Issues', subLabel: 'difficulty falling or staying asleep', icon: 'icon_-Sleep.svg' },
                { label: 'Mood Swings, Anxiety, or Irritability', icon: 'icon_-Anxiety.svg' },
                { label: 'Joint Pain or Stiffness', icon: 'icon_-Joint-Pain.svg' },
                { label: 'Digestive Problems', subLabel: 'bloating, irregularity', icon: 'icon_-Digestive.svg' },
                { label: 'Cold Hands and Feet', subLabel: 'could indicate slow metabolism', icon: 'icon_-Cold-Hand.svg' },
                { label: 'Urinary Issues', subLabel: 'e.g., frequency, urgency', icon: 'icon_-Urinary.svg' }
            ],
            femaleSymptoms: [
                { label: 'Brain Fog, Difficulty Focusing', icon: 'icon_-Brain.svg' },
                { label: 'Low Energy', icon: 'icon_-low-Energy.svg' },
                { label: 'Difficulty Losing Weight', icon: 'Lose-Weight.svg' },
                { label: 'Increased Body Fat', subLabel: 'especially around the abdomen', icon: 'icon_-Body-Fat.svg' },
                { label: 'Muscle Weakness or Loss', subLabel: 'including reduced strength', icon: 'icon_-Weak.svg' },
                { label: 'Hair Thinning or Hair Loss', icon: 'icon_-Hair-Loss.svg' },
                { label: 'Poor Skin Quality', subLabel: 'wrinkles, sagging, dryness', icon: 'icon_-Skin.svg' },
                { label: 'Mood Swings, Anxiety, or Irritability', icon: 'icon_-Anxiety.svg' },
                { label: 'Sleep Issues', subLabel: 'difficulty falling or staying asleep', icon: 'icon_-Sleep.svg' },
                { label: 'Hot Flashes/Night Sweats', icon: 'icon_-Sweats.svg' },
                { label: 'Joint Pain or Stiffness', icon: 'icon_-Joint-Pain.svg' },
                { label: 'Digestive Problems', subLabel: 'bloating, irregularity', icon: 'icon_-Digestive.svg' },
                { label: 'Vaginal Dryness', icon: 'icon_-Vdryness.svg' },
                { label: 'Swollen or Tender Breasts', icon: 'icon_-Breast.svg' },
                { label: 'Urinary Issues', subLabel: 'e.g., frequency, urgency', icon: 'icon_-Urinary.svg' },
                { label: 'Cold Hands and Feet', subLabel: 'could indicate slow metabolism', icon: 'icon_-Cold-Hand.svg' },
                { label: 'Increased Stress Levels', icon: 'icon_-stress.svg' }
            ]
        }
    },
    computed:{
        medicalcon(){
            if(this.people.gender=='Male'){
                return this.medical_cond_to_ask;
            }else{
                return [
                    "Pregnant",
                    "Breast Feeding",
                    ...this.medical_cond_to_ask
                ];
            }
        }
    },
    methods: {
        nextQuestion() {
            this.questionId++
            this.scrolltoTop()
        },
        setValue(field, value) {
            this.people[field] = value
            if (field === 'currently_taking_glp' && value === 'No') {
                this.questionId += 3
            } else if (field === 'want_coach') {
                this.moveToCheckout()
            } else {
                this.nextQuestion()
            }
        }, 
        validateDOB() {
            const { mm, dd, yyyy } = this.people.dob
            if (!this.isValidDate(mm, dd, yyyy)) {
                this.isError = true
                return
            }
            const today = new Date()
            const birthDate = new Date(yyyy, mm - 1, dd)
            let age = today.getFullYear() - birthDate.getFullYear()
            const monthDiff = today.getMonth() - birthDate.getMonth()
            
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--
            }
            
            if (age < 18 || age > 75) {
                this.disqualifiedLead()
            } else {
                this.nextQuestion()
            }
            this.people.dobMMDDYYYY= `${mm}/${dd}/${yyyy}`
            this.people.age= age;
            this.isError = false
        },
        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day)
            return date instanceof Date && !isNaN(date) &&
                   date.getMonth() === month - 1 &&
                   date.getDate() === parseInt(day) &&
                   date.getFullYear() === parseInt(year)
        },
        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.ft) * 12) + parseInt(this.people.height.inch)
            const weightInPounds = parseInt(this.people.weight)
            this.people.bmi = (weightInPounds * 703) / (heightInInches * heightInInches)
            this.people.heightInInches = heightInInches;
        },
        validateHeightWeight() {
            const height = {
                feet: parseInt(this.people.height.ft),
                inches: parseInt(this.people.height.inch)
            };
            const weight = parseInt(this.people.weight);

            if (isNaN(height.feet) || isNaN(height.inches) || isNaN(weight) ||
                height.feet < 3 || height.feet > 8 ||
                height.inches < 0 || height.inches > 11 ||
                weight < 50 || weight > 500) {
                alert('Please enter valid height and weight measurements');
                return;
            }
            if (this.people.bmi < 27) {
                this.disqualifiedLead()
            } else {
                this.questionId+=2;
            }
        },
        checkMedicalCondition() {
            if (this.people.medical_condition.length > 0) {
                this.disqualifiedLead()
            } else {
                this.nextQuestion()
            }
        },
        checkState() {
            if (["MS", "LA"].includes(this.people.state)) {
                this.disqualifiedLead()
            } else {
                this.nextQuestion()
            }
        },
        disqualifiedLead() {
            this.$router.push('/sorry')
        },
        focusNext(event) {
            const currentInput = event.target
            const nextInput = currentInput.nextElementSibling?.nextElementSibling
            const prevInput = currentInput.previousElementSibling?.previousElementSibling

            if (event.key === "Backspace" && currentInput.value === "" && prevInput) {
                prevInput.focus()
            } else if (currentInput.value.length === currentInput.maxLength && nextInput) {
                nextInput.focus()
            }
        },
        validateEmail() {
            this.isError = false
            this.people.phone = this.people.phone_part.part1 + this.people.phone_part.part2 + this.people.phone_part.part3
            
            if (!this.isEmailValid(this.people.email)) {
                this.isError = true
                return
            }
            this.submitForm()
        },
        isEmailValid(email) {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/
            return regex.test(email)
        },
        async submitForm() {
            try {
                this.loading = true
                this.people.dob_yyyy_mm_dd = `${this.people.dob.yyyy}-${this.people.dob.mm}-${this.people.dob.dd}`
                const response = await this.$axios.post(`${this.baseUrl}/intake-form`, this.people, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                })
                if (response.data.status === 'success') {
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.nextQuestion()
                }
            } catch (error) {
                console.error('Error submitting form:', error)
                alert("An Internal error occurred")
            } finally {
                this.loading = false
            }
        },
        moveToCheckout() {
            //this.markCoach();
            let  cartItem = {
                    id: 18,
                    name: 'Semaglutide',
                    category: 'WEIGHT',
                    price: 199,
                    retail_price: 299,
                    quantity: 1,
                    image: 'https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_images/semaglutide1.png',
                    main_type: "Prescription"
                };

            if(this.people.plan_selected==='Tirzepatide'){
                cartItem = {
                    id: 15,
                    name: 'Tirzepatide',
                    category: 'WEIGHT',
                    price: 349,
                    retail_price: 449,
                    quantity: 1,
                    image: 'https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_images/tirzepatide1.png',
                    main_type: "Prescription"
                };
            }
            this.$store.dispatch('addToCart', cartItem);
            localStorage.setItem("user_form", JSON.stringify(this.people))
            this.$router.push({
                name: 'Checkouts'
            })
        },
        async markCoach() {
            try {
                await this.$axios.post(`${this.baseUrl}/mark-care-coach`, {
                    id: this.people.id,
                    want_coach: 1
                })
            } catch (error) {
                console.error('Error marking coach:', error)
            }
        },
        checkUrlParameters() {
            const urlParams = new URLSearchParams(window.location.search)
            urlParams.forEach((value, key) => {
                this.people[key] = value
            })
            const phone = urlParams.get('phone')
            if (phone) {
                this.people.phone = phone
                this.people.phone_part = {
                    part1: phone.slice(0, 3),
                    part2: phone.slice(3, 6),
                    part3: phone.slice(6)
                }
            }
            this.getAffiliate()
        },
        getCookie(name) {
            const value = `; ${document.cookie}`
            const parts = value.split(`; ${name}=`)
            return parts.length === 2 ? parts.pop().split(';').shift() : null
        },
        getQueryParamOrCookie(url, paramName) {
            const params = new URLSearchParams(new URL(url).search)
            return params.get(paramName) || this.getCookie(paramName)
        },
        getAffiliate() {
            const url = window.location.href
            const keys = ['utm_campaign', 'tid', 'utm_source', 'utm_term', 'utm_medium', 'utm_content']
            keys.forEach(key => {
                const value = this.getQueryParamOrCookie(url, key)
                if (value) {
                    this.people[key] = value
                    if (key === 'utm_campaign') this.people.aff_id = value
                }
            })
        },
        getIPAddress() {
            try {
                this.people.ip_address = this.$store.getters.ipAddress
            } catch (error) {
                console.error('Error getting IP address:', error)
            }
        },
        scrolltoTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    },
    mounted() {
        this.checkUrlParameters()
        this.scrolltoTop()
        this.getIPAddress()
    },
    watch: {
        questionId() {
            this.scrolltoTop()
        }
    }
}
</script>
<style scoped>
.multi-choice-boxes-div {
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
}

.checkbox-field-multibox {
    border: 1px solid #000;
    border-radius: 9px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 48%;
    height: 160px;
    padding: 19px 13px;
    display: flex;
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
}

.checkbox-13-check {
    border: 1px #000;
    width: 100%;
    height: 100%;
    margin-top: 0;
    margin-left: 0;
    position: absolute;
    inset: 0%;
}

.image-384 {
    width: 55px;
    height: 55px;
    margin-bottom: 10px;
    position: relative;
}

.checkbox-label-14-check {
    font-family: var(--mulish);
    color: var(--black);
    text-align: center;
    margin-top: 0;
    font-size: 15px;
    font-weight: 600;
    line-height: 15px;
    position: relative;
}

.w-checkbox:after {
    content: " ";
    clear: both;
    grid-area: 1 / 1 / 2 / 2;
    display: table;
}

/* Add mobile responsiveness */
@media screen and (max-width: 479px) {
    .checkbox-field-multibox {
        width: 100%;
        margin-bottom: 10px;
    }
}
.bmi-result {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
}
</style>